import { ElementWithMeta } from '../../../types';
import { filterNotEmpty } from '../listHelpers';
import { modelToPath } from '../model';

type WithMeta<MODEL> = Pick<ElementWithMeta<MODEL>, 'meta'>;

/**
 * Obtain model paths from Smartform elements with metadata attached
 * @param {SmartformElementWithMeta[]} elements - Smartform elements used in form
 * @return {string[]}
 * Input: [
 *  { type: ElementType.GENDER, meta: [{ model: 'gender' }] },
 *  { type: ElementType.FIRST_LAST_NAME, meta: [{ model: { name: 'first' } }, { model: { name: 'last' } } ]},
 *  { type: ElementType.COST_CENTER, meta: [{ model: 'primaryEngagement', diffModel: { primaryEngagement: 'costCenters' } }] }]
 * Output: ['gender', 'name.first', 'name.last', 'primaryEngagement.costCenters'] - `diffModel` takes precedence over `model`
 */

export function getPathsFromElements<MODEL>(elements: WithMeta<MODEL>[]): string[] {
  return filterNotEmpty(
    elements.map((element) => element.meta.map((it) => modelToPath(it.diffModel ?? it.model, false))).flat(),
    {
      removeEmptyStrings: true
    }
  );
}

/**
 * Return top-level model path for given path
 * @param {string} path - model path to obtain top-level path from it
 * @return {string}
 * Input: 'gender'
 * Output: 'gender'
 *
 * Input: 'name.first'
 * Output: 'name'
 */

export function getRootPath(path: string): string {
  return path.split('.').slice(0, 1).join('');
}
